import React from "react";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { BiEdit} from "react-icons/bi";
import { Col, Row, Table } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminData, deleteUser } from "../../services/authServices";
import MainTitle from "../../components/mainTitile/mainTitle";
import TablePagination from "../../components/pagination/tablePagination";
import CustomButton from "../../components/button/button";
import CustomLoader from "../../components/loader/loader";

const AdminListComponent = () => {
  const [adminD, setAdminD] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [pageData, setPageData] = useState(10);
const [page, setPage] = useState(1);

  let navigate = useNavigate();
  //To take all the data from the backend

  const getadmindata = async () => {
    setLoading(true);
    try {
      const res = await adminData();
      setAdminD(res.data.Data.getAllData);
      setPageCount(res.data.Data.adminDocs);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  // useEffect(() => {
  //   getadmindata();
  // }, []);

  const formpage = () => {
    let path = "/adminForm";
    navigate(path);
  };

  const handleDelete = (userid) => {
    deleteUser(userid).then((res)=>{
    if(res.data.Status === 200){
      getadmindata()
    }
  }).catch((err)=>{
    
    console.log('deleted admin Error',err);
    })
  };

  // pagination logic...


useEffect(() => {
  getadmindata();
}, [page,pageData]);


useEffect(() => {
const pagedatacount = Math.ceil(pageCount / pageData);
setPageCount(pagedatacount);
}, [adminD])

const handleRowSize = (e) =>{
const { innerHTML } = e.target
setPageData(innerHTML)
console.log('row per page size',innerHTML);
}

  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <Row>
        <Col
        // style={{ overflow: "scroll" }}
        >
          <Row>
            <Col sm={10} className="pt-3">
              <MainTitle heading={"admin List"} textAlign={"center"} />
            </Col>

            <Col sm={2}>
              <CustomButton buttonText={"add"} onClick={formpage} />
            </Col>
          </Row>
          <Table bordered hover responsive>
            <thead>
              <tr className="fs-16 fw-700">
                <th>Admin Id</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Password</th>
                <th colSpan={2} className="text-center">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {adminD
                .filter((u) => u.roleIdf === 1)
                ?.map((aItem) => (
                  <tr className="fs-14">
                    <td >
                    {aItem.tmt_userId}
                    </td>
                    <td>{aItem.firstname}</td>
                    <td>{aItem.lastname}</td>
                    <td>{aItem.email}</td>
                    <td>{aItem?.password?.slice(0, 7) + "..."}</td>
                    <td className="text-center">
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/adminForm/${aItem._id}`}
                      >
                        <BiEdit color="green" size={20} />
                        
                      </Link>
                    </td>
                    <td>
                      <Link
                        style={{ textDecoration: "none" }}
                        onClick={() => handleDelete(aItem._id)}
                      >
                        <AiFillDelete color="red" size={20} />
                        
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
{pageCount > 1 &&
<>

          <TablePagination handleRowSize={handleRowSize} setPage={setPage} page={page} pageData={pageData} pageCount={pageCount} />
 </>}
        </Col>
      </Row>
      {/* // </CustomLoader> */}
    </>
  );
};

export default AdminListComponent;
